import mainBookSummary from '../data/mainBookSummary.json';

type MainBookWeek = { weekEnding: string };

/** Last `weekEnding` in the bundled public book series (same source as Open Portfolio UI). */
export function lastMainBookWeekEnding(): string {
  const weeks = (mainBookSummary as { weeks?: MainBookWeek[] }).weeks;
  if (!weeks?.length) {
    return '';
  }
  return weeks[weeks.length - 1].weekEnding;
}

/** e.g. `week ending 2026-10-02` */
export function formatMainBookWeekEndingPhrase(weekEnding: string): string {
  return `week ending ${weekEnding}`;
}

export function mainBookAsOfPhrase(): string {
  const weekEnding = lastMainBookWeekEnding();
  if (!weekEnding) {
    return '';
  }
  return `As of ${formatMainBookWeekEndingPhrase(weekEnding)}.`;
}
